import { Component } from '@angular/core';
import { Model } from 'projects/core/src/include/model';
import { DossierOverview } from '../../../../dossier';
import { ActivatedRoute } from '@angular/router';
import { DossierOverviewsService } from '../../../../services/dossieroverviews.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.css'
})
export class DetailOverviewComponent extends Model<DossierOverview> {

  constructor(
    private route1: ActivatedRoute,
    private dossierOverviewService: DossierOverviewsService,
  ) { 
    super(route1,dossierOverviewService);
  }


  ngOnInit(): void {

    this.title = 'Dettaglio Riepilogo';
    super.ngOnInit.apply(this, arguments); 
    
    
    this.afterGetItem=()=>{
      
      if(!this.record.params || !Array.isArray(this.record.params)){
        try{
          this.record.params=JSON.parse(this.record.params);
        }catch{
          this.record.params={"query":"","query2":"","fields":""};
        }
      }

      if(this.record.params==null){
        this.record.params={"query":"","query2":"","fields":""};
      }
      
    }
    
    this.getItem();



  }


}
